"use client"

interface StatusBadgeProps {
  status: string
}

export function StatusBadge({ status }: StatusBadgeProps) {
  return (
    <span
      className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${status === 'pendente' ? 'bg-yellow-100 text-yellow-800' :
        status === 'em_analise' ? 'bg-blue-100 text-blue-800' :
          status === 'respondida' ? 'bg-green-100 text-green-800' :
            'bg-gray-100 text-gray-800'
        }`}
    >
      {status === 'em_analise' ? 'Em Análise' :
        status.charAt(0).toUpperCase() + status.slice(1)}
    </span>
  )
}
